Vue.component('accordion-component', {
    data: function () {
        return {
            activeTab: 1
        }
    },
});